import createFetchDuck from '../../util/genericEntityDuck';

export const storeKey = 'metricsData';
const duck = createFetchDuck('HEARTBEAT', storeKey, 'flowId', 'heartbeat');

export default duck;
export const { creators, reducer, types, selectors } = duck;
